<form>
  <app-verification-validation [key]="validationKey">

    @if (!patientAttachment.ehrConsultNoteReference) {
      <div>
        <span>Select providers who work at the office that is referenced on the consult note:</span>
        @if (patientAttachment.outboundFaxNumber) {
          <div>
            <small>
              <strong>OFFICE FAX:</strong>
              @if (patientAttachment.associatedOffice) {
                <app-office-fax
                  [office]="patientAttachment.associatedOffice" />
              } @else {
                <app-phone-number [number]="patientAttachment.outboundFaxNumber" />
              }
            </small>
          </div>
        }
      </div>
    }

    @if (!patientAttachment.hasMatchingSpecialtyPmvs) {
      <div class="bg-danger-subtle text-danger-emphasis p-2 my-1 row">
        <div class="col-auto gx-1">
          <fa-icon [icon]="['fas', 'exclamation-triangle']" />
        </div>
        <div class="col">
          Selected provider(s) do not match consult note specialty.
          Update the provider specialty or deselect the provider to proceed with verification.
        </div>
      </div>
    }

    @if (patientAttachment.ehrConsultNoteReference) {
      <div>
        Confirm the provider is referenced on the consult note:
      </div>
    }

    @if (prescriberMatchOptions.length > 0) {
      <div class="prescribers border p-2">
        @for (prescriberMatchOption of prescriberMatchOptions; track prescriberMatchOption) {
          <div
            class="prescriber form-check mb-1">
            <div [ngClass]="{ disabled: prescriberMatchOption.frozen }">
              <input
                type="checkbox"
                [disabled]="prescriberMatchOption.frozen"
                (change)="onPrescriberVerificationChange(prescriberMatchOption.verification)"
                [id]="prescriberMatchOption.npi"
                [name]="prescriberMatchOption.npi"
                class="form-check-input"
                [(ngModel)]="prescriberMatchOption.verification.matches"
                />
              <label [for]="prescriberMatchOption.npi" class="form-check-label">
                <div class="small">
                  <strong>
                    {{ prescriberMatchOption.name | blankValueDash }}
                    ({{ prescriberMatchOption.status | providerOfficeFaxStatus }})
                  </strong>
                </div>
                <div class="small">
                  <app-specialty-badges [specialties]="prescriberMatchOption.specialties" [showBlank]="true" />
                </div>
                <div class="small">
                  <strong>NPI:</strong> {{ prescriberMatchOption.npi }}
                  @if (prescriberMatchOption.isPrescriber) {
                    <span>(Prescriber)</span>
                  }
                </div>
              </label>
            </div>
            @if (prescriberMatchOption.providerOffice) {
              <app-provider-office-association-notes
                [providerOffice]="prescriberMatchOption.providerOffice"
                [enablePopover]="true" />
            }
          </div>
        }
      </div>
    } @else {
      <div class="p-1">
        <small><strong>No Prescribers Found</strong></small>
      </div>
    }
  </app-verification-validation>

  @if (capturePrescriberNotAtOffice) {
    <div class="alert alert-warning p-1 mt-1">
      Our records indicate that the prescriber does not practice at the office associated with the consult note.
    </div>
  }

  @for (missingPrescriber of verifyingPrescribersNotAtOffice; track missingPrescriber) {
    <div class="alert alert-warning p-1 mt-1">
      Our records indicate that prescriber, {{ missingPrescriber.name | blankValueDash }} (NPI {{ missingPrescriber.npi }}) no
      longer practices at the office associated with the consult note.
    </div>
  }
</form>

<div class="mb-1 mt-2">
  <app-additional-details-input
    [frozen]="additionalDetailsFrozen"
    [(value)]="patientAttachment.prescriberMatchVerificationNotes"
    (valueChange)="onAdditionalTextChange()"
    [rows]="5"
    />
</div>


